import React from "react";
import { useWindowDimensions } from "@app/contexts";
import { ScrollView } from "devextreme-react/scroll-view";
import "./serials.scss";
import { FiscalBooks } from "./fiscalBooks";
import { IssuedSerials } from "./issuedElements";
import { SideGroupTitle } from "@app/components/groupTitle";
import { useTranslation } from "react-i18next";
export const FiscalBooksPage = () => {
  const {
    height: fullHeight,
    headersFooters,
    jgDrawerHeight,
  } = useWindowDimensions();
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: "1200px", margin: "auto" }}>
      <SideGroupTitle
        title={t("invoiceBookFormTitle")}
        sideKey={"licenseForm"}
      />
      <ScrollView height={jgDrawerHeight}>
        <div id="serials-in-mirror">
          <div id={"serials-in-edit"}>
            <FiscalBooks />
          </div>
          <div id={"serials-in-view"}>
            <IssuedSerials />
          </div>
        </div>
      </ScrollView>
    </div>
  );
};
